var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"spinner",attrs:{"name":"fade","tag":"div","appear":""}},[_c('v-progress-circular',{key:"progress-circular",attrs:{"size":_vm.size,"width":_vm.width,"color":"#da2a4c","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }